import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

import { commentApi } from '../api/commentApi'
import type { TCommentApi } from '../api/types/commentApi.types'

export const getCommentsOptions = (publicationId: number, enabled?: boolean) =>
  infiniteQueryOptions({
    queryKey: ['comments', publicationId],
    queryFn: ({ signal, pageParam: queryParam }) =>
      commentApi.getComments({ id: publicationId, ...queryParam }, { signal }),
    // It returns the next page parameters if there are more comments to fetch
    // otherwise null.
    getNextPageParam: (lastPage, _pages, { limit, offset, expect }) =>
      // Is some situations, useCreateCommentMutation can lead to negative offset and broken request
      // to avoid this situation we wrap offset+limit with Math.max
      lastPage.length === expect ? { offset: Math.max(0, offset + limit), limit, expect: limit } : null,
    initialPageParam: { offset: 0, limit: 10, expect: 10 },
    retry: 0,
    staleTime: 60 * 1000 * 10, // 10 minutes
    select: (data) => ({
      pages: data.pages.reduce<TCommentApi[]>((acc, page) => {
        acc.push(...page)
        return acc
      }, []),
    }),
    enabled,
  })

export const useCommentsQuery = (publicationId: number, enabled?: boolean) =>
  useInfiniteQuery(getCommentsOptions(publicationId, enabled))
